const __WEBPACK_NAMESPACE_OBJECT__ = SharedDependencies.ClassNames['application'];